//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin";

const getArticles = (pageNo=0,pageSize=5)=>{
    return axios.get(API_URL+"/articles?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getArticleById = (id)=>{
    return axios.get(API_URL+"/articles/"+id)
}
const saveArticles = (data)=>{
    return axios.post(API_URL+"/articles",data)
}
const deleteArticles = (id)=>{
    return axios.delete(API_URL+"/articles/"+id)
}

const getArticlesCategory = ()=>{
    return axios.get(API_URL+"/articles/categories")
}
const getArticlesCategoryById = (id)=>{
    return axios.get(API_URL+"/articles/categories/"+id)
}
const saveArticlesCategory = (data)=>{
    return axios.post(API_URL+"/articles/categories",data)
}
const deleteCategory = (id)=>{
    return axios.delete(API_URL+"/articles/categories/"+id)
}
export default {
    getArticles,
    saveArticles,
    getArticleById,
    deleteArticles,
    getArticlesCategory,
    getArticlesCategoryById,
    saveArticlesCategory,
    deleteCategory

}